import { PropsWithChildren } from 'react'

import { WarningBox } from 'client/components/Gallery/Header/WarningBox'

export const StaticHeader = ({ children }: PropsWithChildren) => (
  <div className="header-wrapper">
    {children}
    <WarningBox />
  </div>
)
